import { Menu, MenuButton } from '@headlessui/react';
import UntitledIcon from '@payaca/untitled-icons';
import { ElementType, FC } from 'react';

import Button, { ButtonProps } from '../Button/Button';
import DropdownMenuItems, { TDropdownItem } from './DropdownMenuItems';

export type IProps = ButtonProps & {
  menuItems: TDropdownItem[];
  label?: string;
  as?: ElementType;
};

const ContextMenuDropdown: FC<IProps> = (props) => {
  const {
    menuItems,
    as = Button,
    label = 'More options',
    ...buttonProps
  } = props;

  return (
    <Menu>
      <MenuButton as={as} {...buttonProps}>
        <UntitledIcon name="dots-vertical.3" className="h-5 w-5" />
        <p className="sr-only">{label}</p>
      </MenuButton>

      <DropdownMenuItems items={menuItems} />
    </Menu>
  );
};

export default ContextMenuDropdown;
